import React from 'react';

import { PERMISSION } from 'src/features/auth/types';
import AuthContext from 'src/features/auth/context/AuthContext';

export default function useHasPermissions(permissions: PERMISSION[], any = false): boolean {
    const { permissions: contextPermissions } = React.useContext(AuthContext);
    return React.useMemo(() => {
        if (any) return permissions.some((permission) => contextPermissions.includes(permission));
        return permissions.every((permission) => contextPermissions.includes(permission));
    }, [permissions, contextPermissions, any]);
}
